import { EventEmitter, Injectable, ComponentFactoryResolver, ViewContainerRef } from "@angular/core";
import { ApiService } from "./api.service";
import * as _ from "lodash";
import { JwtHelper } from "./jwt-helper";
import { Router } from "@angular/router";
import { Member } from "../_models";
import { DependentService } from "./dependent.service";
import { Dependent } from "../_models/dependent.model";
import { BehaviorSubject, Observer } from "rxjs";

@Injectable()
export class MemberService {

    _currentMember: Member;
    private _currentDependent: BehaviorSubject<Dependent> = new BehaviorSubject<Dependent>(null);
    public currentDependent = this._currentDependent.asObservable()
    memberId: string;
    isDependent: boolean = false;
    private _isLoggedin: boolean = false;
    public memberChanged: EventEmitter<Member> = new EventEmitter();

    constructor(private router: Router, private componentFactoryResolver: ComponentFactoryResolver, private apiService: ApiService, private dependentService: DependentService) {
        this.currentMember =  JSON.parse(localStorage.getItem('currentMember'));
        // this.currentDependent =  JSON.parse(localStorage.getItem('currentDependent'));
        var openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));
        // console.log(this.currentDependent, this.currentMember)
        if(!openIdTokenParams){
            //this.router.navigateByUrl('/login');
            return;
        }
        let jwtHelper = new JwtHelper();
        let decodedIdToken = jwtHelper.decodeToken(openIdTokenParams.id_token);
        if (decodedIdToken.EntityType) {
            // this.getDependent(decodedIdToken.sub)
        }
        this.memberId = decodedIdToken.sub;

        this.getMember(this.memberId);

    }

    public setDependent(dependent: Dependent){
        this._currentDependent.next(dependent);
    }

    public get isLoggedin(){
        return this._isLoggedin;
    }
 
    public set isLoggedin(value){

        this._isLoggedin = value;
    }

   public get currentMember(){
       return this._currentMember;
   }

   public set currentMember(value){
       if(value && value.memberId){
        this._currentMember = value;
        localStorage.setItem('currentMember',  JSON.stringify(value));
       }
   }
   
//    public set currentDependent(value){
//        if (value && value.dependentId) {
//            this._currentDependent = value;
//             localStorage.setItem('currentDependent',  JSON.stringify(value));
//        }
//    }

//    public get currentDependent(){
//        return this._currentDependent;
//    }

   public logout(){
    localStorage.removeItem('currentMember');
    localStorage.removeItem('currentDependent');
    localStorage.removeItem('openIdTokenParams');
    delete this.currentMember ;
    delete this.memberId ;
    this.isLoggedin = false;
    this._currentDependent.next(null);

   }


   private getMember(memberId):void{

    this.apiService.getMemberById(this.memberId).subscribe(r=>{
        this.currentMember = r;
        this.isLoggedin = true;
    })
   }



}




// WEBPACK FOOTER //
// ./src/app/_services/member.service.ts